import { render, staticRenderFns } from "./mandates-table.vue?vue&type=template&id=e7815cda"
import script from "./mandates-table.vue?vue&type=script&lang=js"
export * from "./mandates-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports